export default __webpack_public_path__ + "static/media/(16).b9337c38.jpg";